document.addEventListener("DOMContentLoaded", () => {
  function loadKlaviyoReviews() {
    const head = document.getElementsByTagName("head")[0];
    const exists = document.getElementById("klaviyo-reviews");

    if (!!exists) {
      exists.remove();
    }

    if (window.klaviyoModulesObject) {
      Object.keys(window.klaviyoModulesObject.loadedModules).forEach((m) => (window.klaviyoModulesObject.loadedModules[m] = undefined));
    }

    const script = document.createElement("script");
    script.defer = true;
    script.id = "klaviyo-reviews";
    script.src = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VkiwQT";

    head.appendChild(script);
  }

  // Select the node that will be observed for mutations
  const targetNode = document.getElementById("product-grid");

  // Options for the observer (which mutations to observe)
  const config = { childList: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        loadKlaviyoReviews();
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

});
